import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Pages
import LoginPage from './pages/LoginPage';
import ConsentPage from './pages/ConsentPage';
import BasicInfoPage from './pages/BasicInfoPage';
import SurveyPage from './pages/SurveyPage';
import CompletionPage from './pages/CompletionPage';
import AdminMembersPage from './pages/admin/AdminMembersPage';
import AdminMemberDetailPage from './pages/admin/AdminMemberDetailPage';
import AdminExportPage from './pages/admin/AdminExportPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/consent"
              element={
                <ProtectedRoute>
                  <ConsentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/basic-info"
              element={
                <ProtectedRoute>
                  <BasicInfoPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/survey"
              element={
                <ProtectedRoute>
                  <SurveyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/completed"
              element={
                <ProtectedRoute>
                  <CompletionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/members"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminMembersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/members/:memberId"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminMemberDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/export"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminExportPage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
